var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-83"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.36,
    y: 173.88,
    width: 141.98,
    height: 208.17,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.37,
    y: 180.43,
    width: 131.95,
    height: 38.45,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.37,
    y: 186.65,
    width: 7.5,
    height: 32.22,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.62,
    y: 186.65,
    width: 7.5,
    height: 32.22,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.55,
    y: 186.25,
    width: 7.5,
    height: 32.22,
    transform: "translate(-31.62 35.09) rotate(-9.78)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.66,
    y: 190.9,
    width: 7.5,
    height: 27.98,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.89,
    y: 190.9,
    width: 7.5,
    height: 27.98,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.38,
    y: 190.9,
    width: 7.5,
    height: 27.98,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.59,
    y: 190.42,
    width: 7.5,
    height: 27.98,
    transform: "translate(-40.57 39.21) rotate(-12.53)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.89,
    y: 185.05,
    width: 3.75,
    height: 33.82,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.47,
    y: 185.05,
    width: 3.75,
    height: 33.82,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.37,
    y: 224.96,
    width: 131.95,
    height: 38.45,
    transform: "translate(342.7 488.38) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.83,
    y: 231.19,
    width: 7.5,
    height: 32.22,
    transform: "translate(467.15 494.6) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.58,
    y: 231.19,
    width: 7.5,
    height: 32.22,
    transform: "translate(394.66 494.6) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.65,
    y: 230.79,
    width: 7.5,
    height: 32.22,
    transform: "translate(262.63 516.26) rotate(-170.22)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.54,
    y: 235.43,
    width: 7.5,
    height: 27.98,
    transform: "translate(448.57 498.85) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.31,
    y: 235.43,
    width: 7.5,
    height: 27.98,
    transform: "translate(414.12 498.85) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.82,
    y: 235.43,
    width: 7.5,
    height: 27.98,
    transform: "translate(327.14 498.85) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.61,
    y: 234.95,
    width: 7.5,
    height: 27.98,
    transform: "translate(310.34 531.95) rotate(-167.47)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.06,
    y: 229.59,
    width: 3.75,
    height: 33.82,
    transform: "translate(431.86 493) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.47,
    y: 229.59,
    width: 3.75,
    height: 33.82,
    transform: "translate(342.7 493) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.37,
    y: 231.19,
    width: 7.5,
    height: 32.22,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.66,
    y: 235.43,
    width: 7.5,
    height: 27.98,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.89,
    y: 235.43,
    width: 7.5,
    height: 27.98,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.89,
    y: 229.59,
    width: 3.75,
    height: 33.82,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.37,
    y: 269.5,
    width: 131.95,
    height: 38.45,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.11,
    y: 275.72,
    width: 7.5,
    height: 32.22,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.04,
    y: 275.32,
    width: 7.5,
    height: 32.22,
    transform: "translate(-46.17 43.09) rotate(-9.78)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.15,
    y: 279.97,
    width: 7.5,
    height: 27.98,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.38,
    y: 279.97,
    width: 7.5,
    height: 27.98,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.87,
    y: 279.97,
    width: 7.5,
    height: 27.98,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.08,
    y: 279.49,
    width: 7.5,
    height: 27.98,
    transform: "translate(-58.95 49.9) rotate(-12.53)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.38,
    y: 274.12,
    width: 3.75,
    height: 33.82,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.96,
    y: 274.12,
    width: 3.75,
    height: 33.82,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.81,
    y: 275.32,
    width: 7.5,
    height: 32.22,
    transform: "translate(-47.43 28.45) rotate(-9.78)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.63,
    y: 279.97,
    width: 7.5,
    height: 27.98,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.84,
    y: 279.49,
    width: 7.5,
    height: 27.98,
    transform: "translate(-61 31.19) rotate(-12.53)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.73,
    y: 274.12,
    width: 3.75,
    height: 33.82,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.86,
    y: 173.88,
    width: 24.5,
    height: 208.71,
    transform: "translate(176.22 556.47) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.44,377.14H304.63L315.57,288a7.94,7.94,0,0,1,7.67-6.83H414l-13.31,95.93Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.44,377.14h20.81L423.2,288a5.92,5.92,0,0,0-6-6.83h-7.15a8,8,0,0,0-7.67,6.83Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.78,377l3.77-43.1a4.1,4.1,0,0,1,3.57-3.72l1.55-.2a5.49,5.49,0,0,0,4.79-5l.69-7.86a5.51,5.51,0,0,0-5.49-6h34.78a5.51,5.51,0,0,1,5.49,6l-.69,7.86a5.49,5.49,0,0,1-4.79,5l-1.55.2a4.11,4.11,0,0,0-3.57,3.72L418.56,377a6.09,6.09,0,0,1-6.06,5.55H377.72A6.09,6.09,0,0,0,383.78,377Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.06,323.15a13.1,13.1,0,0,0-13.05-12h30.28a13.1,13.1,0,0,1,13,12l3,34.16H291.05Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.56,311.19H275a13.1,13.1,0,0,1,13.05,12l3,34.16h72.12l3-34.16a13.09,13.09,0,0,1,13-12h13.45a5.51,5.51,0,0,1,5.49,6l-.69,7.86a5.49,5.49,0,0,1-4.79,5l-1.55.2a4.1,4.1,0,0,0-3.57,3.72L383.78,377a6.09,6.09,0,0,1-6.06,5.55H276.5a6.09,6.09,0,0,1-6.06-5.55l-3.77-43.1a4.12,4.12,0,0,0-3.57-3.72l-1.55-.2a5.51,5.51,0,0,1-4.8-5l-.68-7.86A5.51,5.51,0,0,1,261.56,311.19Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.16,163.48s-1.11-7.31,4.22-12,4.86-7.47,3.33-7.83-2.92,4.32-5.26,5.61c0,0-.08-6.68,2.3-9.13s3.63-8.8,1.36-8.91-2.49,3.76-3,6.51-3,6.61-3,6.61-.49-6-2-8.43,2.56-8.08,1-10.53-4.39,2.22-4.16,7.49,3.75,10.89,2.93,16.39c0,0-1.55-3.87-2.94-4.22s-2.8-2.9-3.73-3.85-2.11,2.33,0,5.37,7.49,11.19,6.67,17.77Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.34,160.15l1.75,10.95a5.57,5.57,0,0,1-5.5,6.44H99.73a5.57,5.57,0,0,1-5.5-6.44L96,160.15Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.06,
    y: 152.04,
    width: 5.43,
    height: 23.35,
    transform: "translate(425.54 327.44) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.79,
    y: 152.04,
    width: 5.43,
    height: 23.35,
    transform: "translate(373.01 327.44) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.95,
    y: 151.75,
    width: 5.43,
    height: 23.35,
    transform: "translate(279.33 350.75) rotate(-170.22)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.33,
    y: 155.12,
    width: 5.43,
    height: 20.27,
    transform: "translate(412.08 330.51) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.84,
    y: 155.12,
    width: 5.43,
    height: 20.27,
    transform: "translate(387.11 330.51) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.33,
    y: 155.12,
    width: 5.43,
    height: 20.27,
    transform: "translate(324.08 330.51) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.39,
    y: 154.77,
    width: 5.43,
    height: 20.27,
    transform: "translate(314.23 364.31) rotate(-167.47)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.63,
    y: 150.88,
    width: 2.72,
    height: 24.51,
    transform: "translate(399.97 326.28) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.32,
    y: 150.88,
    width: 2.72,
    height: 24.51,
    transform: "translate(335.35 326.28) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.48,
    y: 156.86,
    width: 26.47,
    height: 18.27,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.56,
    y: 164.34,
    width: 22.17,
    height: 13.64,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.46,
    y: 152.35,
    width: 11.09,
    height: 13.64,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.44,
    y: 134.3,
    width: 26.37,
    height: 109.88,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.37,
    y: 134.3,
    width: 98.62,
    height: 110.17,
    transform: "translate(731.35 378.78) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.19,
    y: 134.3,
    width: 102.32,
    height: 110.17,
    transform: "translate(728.69 378.78) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.56,
    y: 137.82,
    width: 93.74,
    height: 101.6,
    transform: "translate(728.86 377.23) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.56,
    y: 137.82,
    width: 1.74,
    height: 101.6,
    transform: "translate(636.85 377.23) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.9,
    y: 165.98,
    width: 2.74,
    height: 92.54,
    transform: "translate(153.03 577.52) rotate(-90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.56,
    y: 206.28,
    width: 95.21,
    height: 4.6,
    transform: "translate(730.32 417.15) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-83"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-83",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tab--inject-83"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.72,
    y: 152.82,
    width: 193.55,
    height: 225.3,
    rx: 7.32,
    style: {
      fill: "#336734"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.72,
    y: 152.82,
    width: 193.55,
    height: 225.3,
    rx: 7.32,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.08,
    y: 256.15,
    width: 130.84,
    height: 22.4,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.78,269.53v.59h-4.54V263.7h4.4v.58h-3.72v2.29h3.32v.57h-3.32v2.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.69,267.35h2.41v.56h-2.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.51,267.32v2.8h-.65v-2.74c0-1-.51-1.54-1.38-1.54a1.55,1.55,0,0,0-1.61,1.74v2.54h-.66v-2.74c0-1-.51-1.54-1.39-1.54a1.55,1.55,0,0,0-1.61,1.74v2.54h-.66v-4.83h.63v.88a2,2,0,0,1,1.77-.92,1.72,1.72,0,0,1,1.71,1,2.12,2.12,0,0,1,1.91-1A1.82,1.82,0,0,1,191.51,267.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.93,267.12v3h-.63v-.76a1.8,1.8,0,0,1-1.66.8c-1.09,0-1.76-.57-1.76-1.4s.48-1.37,1.86-1.37h1.53v-.29c0-.83-.46-1.28-1.36-1.28a2.48,2.48,0,0,0-1.61.57l-.29-.48a3,3,0,0,1,2-.66A1.72,1.72,0,0,1,196.93,267.12Zm-.66,1.55v-.79h-1.51c-.93,0-1.24.36-1.24.86s.45.91,1.22.91A1.53,1.53,0,0,0,196.27,268.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.55,263.77a.47.47,0,0,1,.48-.46.46.46,0,0,1,.47.45.47.47,0,0,1-.47.48A.47.47,0,0,1,198.55,263.77Zm.15,1.52h.65v4.83h-.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.16,263.31h.65v6.81h-.65Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 167.08,
    y: 286.75,
    width: 130.84,
    height: 22.4,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.26,296.53c0,1.37-1,2.2-2.62,2.2h-1.72v2h-.68v-6.42h2.4C178.27,294.33,179.26,295.16,179.26,296.53Zm-.68,0c0-1-.67-1.61-2-1.61h-1.7v3.21h1.7C177.91,298.13,178.58,297.54,178.58,296.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.19,297.76v3h-.63V300a1.8,1.8,0,0,1-1.66.8c-1.09,0-1.76-.57-1.76-1.41S180.62,298,182,298h1.53v-.3c0-.82-.47-1.27-1.37-1.27a2.44,2.44,0,0,0-1.6.57l-.3-.49a3.08,3.08,0,0,1,2-.65A1.72,1.72,0,0,1,184.19,297.76Zm-.65,1.54v-.79H182c-.93,0-1.23.37-1.23.87s.44.9,1.22.9A1.54,1.54,0,0,0,183.54,299.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.29,300.2l.29-.51a3,3,0,0,0,1.72.54c.91,0,1.29-.31,1.29-.79,0-1.26-3.13-.27-3.13-2.17,0-.79.68-1.38,1.91-1.38a3.36,3.36,0,0,1,1.71.45l-.29.52a2.48,2.48,0,0,0-1.42-.41c-.87,0-1.26.34-1.26.8,0,1.3,3.13.32,3.13,2.17,0,.84-.73,1.38-2,1.38A3.2,3.2,0,0,1,185.29,300.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.77,300.2l.3-.51a2.9,2.9,0,0,0,1.71.54c.92,0,1.29-.31,1.29-.79,0-1.26-3.12-.27-3.12-2.17,0-.79.68-1.38,1.9-1.38a3.31,3.31,0,0,1,1.71.45l-.28.52a2.53,2.53,0,0,0-1.43-.41c-.87,0-1.25.34-1.25.8,0,1.3,3.13.32,3.13,2.17,0,.84-.74,1.38-2,1.38A3.25,3.25,0,0,1,189.77,300.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.91,295.93l-1.82,4.82h-.61L198,296.8l-1.52,3.95h-.61L194,295.93h.62l1.52,4.1,1.55-4.1h.56l1.54,4.1,1.53-4.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.27,298.34a2.46,2.46,0,1,1,2.46,2.46A2.38,2.38,0,0,1,202.27,298.34Zm4.25,0a1.8,1.8,0,1,0-1.79,1.88A1.76,1.76,0,0,0,206.52,298.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.94,295.89v.63h-.16a1.56,1.56,0,0,0-1.62,1.77v2.46h-.65v-4.82h.62v.94A1.83,1.83,0,0,1,210.94,295.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.47,294v6.8h-.62v-.95a2.1,2.1,0,0,1-1.86,1,2.46,2.46,0,0,1,0-4.91,2.09,2.09,0,0,1,1.83,1V294Zm-.64,4.39a1.8,1.8,0,1,0-1.79,1.88A1.76,1.76,0,0,0,215.83,298.34Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 167.08,
    y: 332,
    width: 130.84,
    height: 22.4,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M198.9,321.71h-2.14l-.46,1h-.42l1.75-3.83h.4l1.75,3.83h-.42Zm-.15-.33-.92-2.06-.92,2.06Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M200.34,318.67h.39v4.06h-.39Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M203.27,319.83v.38h-.1a.93.93,0,0,0-1,1.06v1.47h-.39v-2.88h.38v.56A1.08,1.08,0,0,1,203.27,319.83Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M206.45,321.41H204a1.06,1.06,0,0,0,1.13,1,1.16,1.16,0,0,0,.89-.37l.21.25a1.52,1.52,0,0,1-2.62-1,1.39,1.39,0,0,1,1.41-1.46,1.37,1.37,0,0,1,1.4,1.46S206.45,321.37,206.45,321.41Zm-2.41-.29h2a1,1,0,0,0-2,0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M209.34,321v1.78H209v-.45a1.06,1.06,0,0,1-1,.48c-.65,0-1-.34-1-.84s.28-.82,1.11-.82H209v-.17c0-.49-.28-.76-.82-.76a1.48,1.48,0,0,0-1,.34l-.17-.29a1.79,1.79,0,0,1,1.17-.39A1,1,0,0,1,209.34,321Zm-.38.92v-.48h-.91c-.56,0-.74.22-.74.52s.27.54.73.54A.94.94,0,0,0,209,321.87Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M213,318.67v4.06h-.37v-.57a1.23,1.23,0,0,1-1.11.6,1.47,1.47,0,0,1,0-2.93,1.28,1.28,0,0,1,1.1.57v-1.73Zm-.38,2.62a1.07,1.07,0,1,0-1.07,1.12A1.05,1.05,0,0,0,212.66,321.29Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M216.55,319.85l-1.44,3.23c-.24.56-.55.74-1,.74a1,1,0,0,1-.7-.26l.18-.29a.75.75,0,0,0,.53.22c.26,0,.43-.12.6-.49l.12-.27-1.29-2.88H214l1.09,2.45,1.08-2.45Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M220.71,321v1.78h-.37v-.45a1.06,1.06,0,0,1-1,.48c-.65,0-1-.34-1-.84s.28-.82,1.11-.82h.91v-.17c0-.49-.27-.76-.81-.76a1.48,1.48,0,0,0-1,.34l-.18-.29a1.82,1.82,0,0,1,1.18-.39A1,1,0,0,1,220.71,321Zm-.39.92v-.48h-.9c-.56,0-.74.22-.74.52s.27.54.73.54A.92.92,0,0,0,220.32,321.87Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M228,321.06v1.67h-.38V321.1c0-.61-.31-.92-.83-.92a.93.93,0,0,0-1,1v1.51h-.38V321.1c0-.61-.31-.92-.84-.92a.93.93,0,0,0-1,1v1.51h-.39v-2.88h.37v.53a1.16,1.16,0,0,1,1.06-.55,1,1,0,0,1,1,.61,1.25,1.25,0,0,1,1.14-.61A1.08,1.08,0,0,1,228,321.06Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M231.54,321.41h-2.41a1.08,1.08,0,0,0,1.14,1,1.13,1.13,0,0,0,.88-.37l.22.25a1.45,1.45,0,0,1-1.11.47,1.42,1.42,0,0,1-1.51-1.47,1.4,1.4,0,1,1,2.8,0S231.54,321.37,231.54,321.41Zm-2.41-.29h2.05a1,1,0,0,0-2.05,0Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M237.1,321.06v1.67h-.39V321.1c0-.61-.3-.92-.82-.92a.92.92,0,0,0-1,1v1.51h-.39V321.1c0-.61-.3-.92-.83-.92a.92.92,0,0,0-1,1v1.51h-.39v-2.88h.37v.53a1.15,1.15,0,0,1,1.06-.55,1,1,0,0,1,1,.61,1.25,1.25,0,0,1,1.14-.61A1.08,1.08,0,0,1,237.1,321.06Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M241.08,321.29a1.4,1.4,0,0,1-1.43,1.47,1.23,1.23,0,0,1-1.11-.6v.57h-.38v-4.06h.39v1.73a1.27,1.27,0,0,1,1.1-.57A1.39,1.39,0,0,1,241.08,321.29Zm-.39,0a1.07,1.07,0,1,0-1.07,1.12A1.05,1.05,0,0,0,240.69,321.29Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M244.39,321.41H242a1.06,1.06,0,0,0,1.13,1A1.13,1.13,0,0,0,244,322l.22.25a1.52,1.52,0,0,1-2.62-1,1.39,1.39,0,0,1,1.41-1.46,1.36,1.36,0,0,1,1.39,1.46Zm-2.41-.29h2a1,1,0,0,0-2,0Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M246.64,319.83v.38h-.09a.93.93,0,0,0-1,1.06v1.47h-.39v-2.88h.37v.56A1.09,1.09,0,0,1,246.64,319.83Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M249.16,319.88c0-.4-.32-.67-.88-.67a1.3,1.3,0,0,0-1.05.44l-.29-.22a1.7,1.7,0,0,1,1.37-.57c.77,0,1.26.37,1.26,1,0,.93-1,1-1,1.76h-.41C248.16,320.68,249.16,320.59,249.16,319.88Zm-1.08,2.59a.29.29,0,0,1,.57,0,.29.29,0,1,1-.57,0Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M251.87,318.9h.89V322h1.92v.72h-2.81Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M254.88,321.26a1.62,1.62,0,1,1,1.62,1.52A1.52,1.52,0,0,1,254.88,321.26Zm2.37,0a.75.75,0,1,0-.75.81A.74.74,0,0,0,257.25,321.26Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M261.73,319.78v2.46a1.44,1.44,0,0,1-1.65,1.6,2.44,2.44,0,0,1-1.45-.41l.34-.61a1.77,1.77,0,0,0,1,.33c.6,0,.87-.27.87-.8v-.13a1.21,1.21,0,0,1-.93.37,1.43,1.43,0,1,1,0-2.85,1.18,1.18,0,0,1,1,.42v-.38Zm-.84,1.39a.71.71,0,0,0-.77-.73.73.73,0,1,0,0,1.45A.71.71,0,0,0,260.89,321.17Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M264,318.9a.49.49,0,0,1,.53-.48.48.48,0,0,1,.53.46.53.53,0,0,1-1.06,0Zm.1.88h.85v3h-.85Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M268.74,321v1.69h-.85v-1.55c0-.48-.22-.7-.6-.7s-.71.25-.71.79v1.46h-.85v-3h.82v.35a1.29,1.29,0,0,1,1-.39A1.15,1.15,0,0,1,268.74,321Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 167.08,
    y: 330.63,
    width: 130.84,
    height: 22.4,
    style: {
      fill: "#336734"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.6,345.31,214,343l-.48,0h-1.9v2.33h-1.1v-7.67h3c2,0,3.19,1,3.19,2.68a2.42,2.42,0,0,1-1.68,2.42l1.82,2.57Zm0-5c0-1.1-.73-1.72-2.14-1.72h-1.86v3.45h1.86C214.84,342.05,215.57,341.41,215.57,340.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.52,342.76h-4.71a2,2,0,0,0,2.1,1.7,2.18,2.18,0,0,0,1.68-.7l.58.68a3.17,3.17,0,0,1-5.42-2,2.85,2.85,0,0,1,2.92-3,2.8,2.8,0,0,1,2.87,3C223.54,342.53,223.53,342.66,223.52,342.76Zm-4.71-.76h3.72a1.87,1.87,0,0,0-3.72,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.56,339.51v5c0,2.05-1.05,3-3,3a4.3,4.3,0,0,1-2.77-.86l.5-.81a3.57,3.57,0,0,0,2.24.75c1.37,0,2-.63,2-1.95v-.46a2.63,2.63,0,0,1-2.09.9,2.81,2.81,0,1,1,0-5.62,2.64,2.64,0,0,1,2.15,1v-.9Zm-1,2.75a2,2,0,1,0-2,1.89A1.86,1.86,0,0,0,229.53,342.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.38,337.71a.7.7,0,0,1,.71-.69.69.69,0,1,1,0,1.37A.69.69,0,0,1,232.38,337.71Zm.19,1.8h1.05v5.8h-1.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.89,344.7l.44-.83a3.72,3.72,0,0,0,2,.6c1,0,1.38-.3,1.38-.79,0-1.3-3.67-.17-3.67-2.49,0-1,.93-1.74,2.42-1.74a4.2,4.2,0,0,1,2.11.53l-.45.83a3,3,0,0,0-1.67-.46c-.92,0-1.37.34-1.37.8,0,1.37,3.68.25,3.68,2.51,0,1-1,1.72-2.51,1.72A4.22,4.22,0,0,1,234.89,344.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.38,345a2,2,0,0,1-1.27.41,1.66,1.66,0,0,1-1.84-1.82v-3.19h-1v-.86h1v-1.27h1v1.27H244v.86h-1.67v3.15a.85.85,0,0,0,.91,1,1.34,1.34,0,0,0,.82-.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.68,342.76H246a2,2,0,0,0,2.11,1.7,2.15,2.15,0,0,0,1.67-.7l.58.68a3.16,3.16,0,0,1-5.41-2,2.85,2.85,0,0,1,2.92-3,2.81,2.81,0,0,1,2.87,3A1.82,1.82,0,0,1,250.68,342.76ZM246,342h3.73a1.88,1.88,0,0,0-3.73,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.29,339.45v1h-.24a1.73,1.73,0,0,0-1.83,2v2.89h-1.05v-5.8h1v1A2.2,2.2,0,0,1,255.29,339.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.59,177.61l.45-.94a4.28,4.28,0,0,0,2.77,1c1.45,0,2.07-.56,2.07-1.29,0-2-5.08-.76-5.08-3.87,0-1.3,1-2.4,3.21-2.4a5,5,0,0,1,2.7.74l-.4,1a4.31,4.31,0,0,0-2.3-.68c-1.43,0-2,.6-2,1.33,0,2,5.09.76,5.09,3.85,0,1.28-1,2.38-3.25,2.38A5,5,0,0,1,209.59,177.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.44,170.24a.76.76,0,0,1,.78-.75.75.75,0,0,1,.78.73.78.78,0,0,1-1.56,0Zm.2,2h1.16v6.36h-1.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.07,172.21v5.49c0,2.25-1.14,3.27-3.29,3.27a4.74,4.74,0,0,1-3-.95l.55-.89a3.85,3.85,0,0,0,2.45.83c1.5,0,2.18-.7,2.18-2.14v-.5a2.9,2.9,0,0,1-2.29,1,3.08,3.08,0,1,1,0-6.15,2.91,2.91,0,0,1,2.35,1v-1Zm-1.12,3a2.19,2.19,0,1,0-2.19,2.08A2.06,2.06,0,0,0,226,175.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.31,174.91v3.66h-1.16V175c0-1.25-.62-1.86-1.71-1.86a1.89,1.89,0,0,0-2,2.11v3.28h-1.15v-6.36h1.11v1a2.7,2.7,0,0,1,2.29-1A2.47,2.47,0,0,1,235.31,174.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.6,172.21v6.36h-1.09v-1a2.59,2.59,0,0,1-2.16,1,2.5,2.5,0,0,1-2.74-2.77v-3.66h1.15v3.53c0,1.24.63,1.87,1.72,1.87a1.88,1.88,0,0,0,2-2.11v-3.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.38,175.39a3.09,3.09,0,0,1-3.21,3.25,2.73,2.73,0,0,1-2.22-1v3.28H248.8v-8.68h1.1v1a2.71,2.71,0,0,1,2.27-1.07A3.08,3.08,0,0,1,255.38,175.39Zm-1.16,0a2.14,2.14,0,1,0-2.15,2.24A2.11,2.11,0,0,0,254.22,175.39Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 167.08,
    y: 225.54,
    width: 130.84,
    height: 22.4,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.24,233.09h.68v5.83h3.59v.59h-4.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.16,236.52v3h-.62v-.75a1.84,1.84,0,0,1-1.66.8c-1.09,0-1.76-.57-1.76-1.41s.47-1.36,1.86-1.36h1.53v-.29c0-.83-.47-1.28-1.37-1.28a2.44,2.44,0,0,0-1.6.57l-.3-.49a3.11,3.11,0,0,1,2-.65A1.72,1.72,0,0,1,183.16,236.52Zm-.65,1.54v-.79H181c-.94,0-1.24.37-1.24.87s.45.9,1.22.9A1.54,1.54,0,0,0,182.51,238.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.26,239l.29-.51a3,3,0,0,0,1.72.54c.92,0,1.29-.31,1.29-.79,0-1.26-3.12-.27-3.12-2.17,0-.79.67-1.38,1.9-1.38a3.31,3.31,0,0,1,1.71.45l-.29.52a2.48,2.48,0,0,0-1.42-.41c-.87,0-1.25.34-1.25.8,0,1.3,3.12.32,3.12,2.17,0,.84-.73,1.38-2,1.38A3.24,3.24,0,0,1,184.26,239Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,239.22a1.57,1.57,0,0,1-1,.34,1.28,1.28,0,0,1-1.41-1.41v-2.91h-.87v-.55h.87v-1.06h.65v1.06h1.46v.55h-1.46v2.88a.77.77,0,0,0,.83.88,1.07,1.07,0,0,0,.72-.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,233.09v6.42h-.56l-4.12-5.21v5.21h-.68v-6.42h.56l4.13,5.21v-5.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.64,236.52v3H206v-.75a1.82,1.82,0,0,1-1.66.8c-1.09,0-1.76-.57-1.76-1.41s.48-1.36,1.87-1.36H206v-.29c0-.83-.47-1.28-1.37-1.28a2.44,2.44,0,0,0-1.6.57l-.3-.49a3.08,3.08,0,0,1,2-.65A1.72,1.72,0,0,1,206.64,236.52Zm-.65,1.54v-.79h-1.52c-.93,0-1.23.37-1.23.87s.45.9,1.22.9A1.54,1.54,0,0,0,206,238.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.37,236.71v2.8h-.65v-2.73c0-1-.52-1.54-1.39-1.54a1.55,1.55,0,0,0-1.61,1.74v2.53h-.65v-2.73c0-1-.52-1.54-1.4-1.54a1.55,1.55,0,0,0-1.61,1.74v2.53h-.65v-4.82H209v.88a2,2,0,0,1,1.77-.92,1.74,1.74,0,0,1,1.72,1,2.1,2.1,0,0,1,1.9-1A1.82,1.82,0,0,1,216.37,236.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.36,237.3h-4a1.79,1.79,0,0,0,1.9,1.68,1.91,1.91,0,0,0,1.48-.63l.36.42a2.55,2.55,0,0,1-4.39-1.67,2.33,2.33,0,0,1,2.36-2.45,2.3,2.3,0,0,1,2.34,2.45C222.37,237.16,222.36,237.23,222.36,237.3Zm-4-.48h3.42a1.71,1.71,0,0,0-3.42,0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 167.08,
    y: 194.94,
    width: 130.84,
    height: 22.4,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.92,203.08v2.52h3.32v.59h-3.32v2.72h-.68v-6.42h4.4v.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.67,202.56a.48.48,0,1,1,.47.47A.47.47,0,0,1,179.67,202.56Zm.14,1.53h.65v4.82h-.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.71,204.05v.63h-.16a1.56,1.56,0,0,0-1.62,1.78v2.46h-.65v-4.82h.62V205A1.83,1.83,0,0,1,184.71,204.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.25,208.36l.29-.52a2.89,2.89,0,0,0,1.72.55c.92,0,1.29-.32,1.29-.79,0-1.26-3.12-.27-3.12-2.18,0-.78.67-1.37,1.9-1.37a3.21,3.21,0,0,1,1.71.45l-.29.52a2.48,2.48,0,0,0-1.42-.41c-.87,0-1.25.34-1.25.8,0,1.3,3.12.32,3.12,2.17,0,.83-.73,1.37-2,1.37A3.24,3.24,0,0,1,185.25,208.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,208.62a1.62,1.62,0,0,1-1,.33,1.27,1.27,0,0,1-1.41-1.4v-2.91h-.87v-.55h.87V203h.65v1.06h1.46v.55h-1.46v2.87a.78.78,0,0,0,.83.89,1.12,1.12,0,0,0,.72-.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,202.49v6.42h-.56l-4.12-5.21v5.21h-.68v-6.42h.56l4.13,5.21v-5.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.63,205.92v3H207v-.75a1.8,1.8,0,0,1-1.65.79c-1.1,0-1.77-.56-1.77-1.4s.48-1.36,1.87-1.36H207v-.3c0-.82-.47-1.27-1.37-1.27a2.44,2.44,0,0,0-1.6.57l-.3-.49a3.09,3.09,0,0,1,2-.65A1.71,1.71,0,0,1,207.63,205.92Zm-.65,1.54v-.79h-1.52c-.93,0-1.23.37-1.23.86s.45.91,1.22.91A1.55,1.55,0,0,0,207,207.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.36,206.11v2.8h-.65v-2.73c0-1-.52-1.54-1.39-1.54a1.55,1.55,0,0,0-1.61,1.74v2.53h-.65v-2.73c0-1-.52-1.54-1.4-1.54a1.55,1.55,0,0,0-1.61,1.74v2.53h-.65v-4.82H210V205a2,2,0,0,1,1.77-.92,1.74,1.74,0,0,1,1.72,1,2.08,2.08,0,0,1,1.9-1A1.82,1.82,0,0,1,217.36,206.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.35,206.7h-4a1.79,1.79,0,0,0,1.9,1.68,1.89,1.89,0,0,0,1.48-.64l.36.43a2.55,2.55,0,0,1-4.39-1.67,2.33,2.33,0,0,1,2.36-2.45,2.3,2.3,0,0,1,2.34,2.45C223.36,206.55,223.35,206.62,223.35,206.7Zm-4-.49h3.42a1.71,1.71,0,0,0-3.42,0Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.85,385.28l-.95,0c0-1.41,1.17-34.45,6.92-40,5.91-5.75,12.86-.08,12.92,0l-.6.72c-.26-.21-6.37-5.17-11.67,0C119,351.21,117.86,384.94,117.85,385.28Z",
    style: {
      fill: "#336734"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.37,391.91l-.94-.09c0-.4,3.72-40.12-10.67-56.64l.71-.62C121.13,351.39,117.41,391.51,117.37,391.91Z",
    style: {
      fill: "#336734"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.83,387.67c-.12-1.88-2.89-46,8.17-56.2l.64.7c-10.73,9.86-7.9,55-7.87,55.43Z",
    style: {
      fill: "#336734"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.43,387.64c0-.3-.34-30-8.21-34.47a5,5,0,0,0-4.58-.48c-4.61,1.91-7.06,10.71-7.09,10.8l-.91-.25c.1-.38,2.6-9.33,7.64-11.42a5.89,5.89,0,0,1,5.41.53c8.33,4.77,8.68,34,8.69,35.28Z",
    style: {
      fill: "#336734"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.67,387.66c-.06-1-1.27-23.44,5.1-31.77,1.7-2.21,3.58-3.26,5.62-3.11,4.53.31,8,6.45,8.19,6.71l-.82.47c0-.06-3.42-6-7.44-6.24-1.69-.13-3.31.8-4.8,2.75-6.16,8-4.92,30.91-4.91,31.14Z",
    style: {
      fill: "#336734"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.4,390.77l-.94-.07c0-.54,4-54.12-2.6-63.06l.76-.56C122.44,336.3,118.57,388.55,118.4,390.77Z",
    style: {
      fill: "#336734"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.45,357.15s4.08,1.51,2.87,5.06-14.13,9.4-14.13,9.4-5.41-4.95-.44-13S101.34,354.61,101.45,357.15Z",
    style: {
      fill: "#336734"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.45,357.15s4.08,1.51,2.87,5.06-14.13,9.4-14.13,9.4-5.41-4.95-.44-13S101.34,354.61,101.45,357.15Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.2,350.39s-4.35-.18-4.6,3.56S124,368.07,124,368.07s6.9-2.5,5.42-11.85S120.28,348.08,119.2,350.39Z",
    style: {
      fill: "#336734"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.2,350.39s-4.35-.18-4.6,3.56S124,368.07,124,368.07s6.9-2.5,5.42-11.85S120.28,348.08,119.2,350.39Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.88,332.45s-2.9-.31-2.67-2.07,11.27-6.31,17.78,1c0,0-4.17,7.16-10.19,7.26S122.88,332.45,122.88,332.45Z",
    style: {
      fill: "#336734"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.88,332.45s-2.9-.31-2.67-2.07,11.27-6.31,17.78,1c0,0-4.17,7.16-10.19,7.26S122.88,332.45,122.88,332.45Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.48,328.16s2.62,1.27,3.36-.35-6.23-11.31-15.64-8.52c0,0-.25,8.28,4.81,11.55S117.48,328.16,117.48,328.16Z",
    style: {
      fill: "#336734"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.48,328.16s2.62,1.27,3.36-.35-6.23-11.31-15.64-8.52c0,0-.25,8.28,4.81,11.55S117.48,328.16,117.48,328.16Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.2,355.73s-2-1.62.16-2.41,12.75-.56,12.86,9.93c0,0-12.34,2.05-13.86-1.95S131.2,355.73,131.2,355.73Z",
    style: {
      fill: "#336734"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.2,355.73s-2-1.62.16-2.41,12.75-.56,12.86,9.93c0,0-12.34,2.05-13.86-1.95S131.2,355.73,131.2,355.73Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,332.19s2-1.62-.16-2.4-12.75-.57-12.86,9.92c0,0,12.34,2.06,13.86-1.94S106,332.19,106,332.19Z",
    style: {
      fill: "#336734"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,332.19s2-1.62-.16-2.4-12.75-.57-12.86,9.92c0,0,12.34,2.06,13.86-1.94S106,332.19,106,332.19Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.56,340.64s.18-2-1.41-1.19-7.1,6.73-1.38,12.38c0,0,7.71-5.71,6.32-8.68S112.56,340.64,112.56,340.64Z",
    style: {
      fill: "#336734"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.56,340.64s.18-2-1.41-1.19-7.1,6.73-1.38,12.38c0,0,7.71-5.71,6.32-8.68S112.56,340.64,112.56,340.64Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,343.44s-1.2-1.57.56-1.76,9.6,1.9,7.77,9.74c0,0-9.56-.72-10-4S133,343.44,133,343.44Z",
    style: {
      fill: "#336734"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,343.44s-1.2-1.57.56-1.76,9.6,1.9,7.77,9.74c0,0-9.56-.72-10-4S133,343.44,133,343.44Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.16 416.72 133.07 416.72 137.18 386.66 98.05 386.66 102.16 416.72",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.16 416.72 133.07 416.72 137.18 386.66 98.05 386.66 102.16 416.72",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.06,384.22v2.86a3.46,3.46,0,0,1-3.46,3.46H97.25a3.46,3.46,0,0,1-3.46-3.46v-2.86Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.62,99.31H369.89a8.84,8.84,0,0,0-8.84,8.84v25a8.84,8.84,0,0,0,8.84,8.85h8.39l-2,7.89,8-7.89h14.39a8.85,8.85,0,0,0,8.85-8.85v-25A8.84,8.84,0,0,0,398.62,99.31Z",
    style: {
      fill: "#336734"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.62,99.31H369.89a8.84,8.84,0,0,0-8.84,8.84v25a8.84,8.84,0,0,0,8.84,8.85h8.39l-2,7.89,8-7.89h14.39a8.85,8.85,0,0,0,8.85-8.85v-25A8.84,8.84,0,0,0,398.62,99.31Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384.26,
    cy: 120.55,
    r: 11.15,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.26,106.29a14.26,14.26,0,1,0,14.26,14.26A14.25,14.25,0,0,0,384.26,106.29Zm8.09,10-8.59,10.12a1.28,1.28,0,0,1-1,.46,1.3,1.3,0,0,1-1-.46l-5.59-6.59a1.31,1.31,0,1,1,2-1.69l4.59,5.41,7.59-8.94a1.31,1.31,0,0,1,2,1.69Z",
    style: {
      fill: "#336734"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.64,253.56s-17.41-2.2-43.79,5c0,0-4.24-47.14-3.74-53.62s40.73-4.58,40.73-4.58,1,18.87,3.62,30.25S395,251.37,393.64,253.56Z",
    style: {
      fill: "#336734"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.64,253.56s-17.41-2.2-43.79,5c0,0-4.24-47.14-3.74-53.62s40.73-4.58,40.73-4.58,1,18.87,3.62,30.25S395,251.37,393.64,253.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.13 409.62 344.23 411.63 345.92 400.58 346.83 394.67 339.73 392.66 338.52 400.58 337.13 409.62",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.95 410.2 385.27 411.17 385.34 400.58 385.39 394 378.06 393.04 378.01 400.58 377.95 410.2",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.06 393.04 378.01 400.58 385.34 400.58 385.39 394 378.06 393.04",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.52 400.58 345.92 400.58 346.83 394.67 339.73 392.66 338.52 400.58",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.61,208.81l-7.05-2.08,1.29,8.05s6.4,1.47,7-1.86Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.52 208.6 294.98 215.14 299.85 214.78 298.56 206.73 291.52 208.6",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.34 210.87 303.76 208.28 302.71 213.9 313.22 216.46 315.34 210.87",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.37,205.79l-.68.81c-1.46,1.71-5,5.84-8.69,9.4-3,2.9-6,5.43-8,5.94-5.67,1.46-26.28-4.61-26.28-4.61l2.13-8.36s19.2,2.55,20.69,2.55c1.13,0,12.81-16.92,15.64-18.31Z",
    style: {
      fill: "#336734"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.69,206.6c-1.46,1.71-5,5.84-8.69,9.4.74-5.86,2.89-11.24,5.72-14.64a5.28,5.28,0,0,1,.9-.88Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.22,408.51l8.06-.21a.64.64,0,0,1,.64.48l1.7,6.49a1.07,1.07,0,0,1-1,1.34c-2.91,0-7.12,0-10.77.07-4.28.12-7-.09-12,0-3,.08-4-2.94-2.72-3.25,5.73-1.42,9.48-1.14,14.36-4.34A3.49,3.49,0,0,1,337.22,408.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.52,409.55h0c-1.18.26-3.28.61-4.12-.08a1,1,0,0,1-.36-.84.54.54,0,0,1,.27-.47c.89-.53,3.9.9,4.25,1.06a.19.19,0,0,1,.1.17A.17.17,0,0,1,336.52,409.55Zm-4-1.11-.06,0a.22.22,0,0,0-.11.19.65.65,0,0,0,.23.55c.47.39,1.69.43,3.31.11C334.72,408.8,333.09,408.23,332.54,408.44Z",
    style: {
      fill: "#336734"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.52,409.55h-.12c-.91-.38-2.73-1.92-2.63-2.75,0-.2.16-.45.64-.51a1.35,1.35,0,0,1,1,.27c1,.75,1.23,2.72,1.25,2.8a.18.18,0,0,1-.07.16Zm-2.24-2.87c-.15.05-.16.13-.16.16-.06.5,1.18,1.72,2.11,2.24a4,4,0,0,0-1.06-2.24.9.9,0,0,0-.72-.2A.61.61,0,0,0,334.28,406.68Z",
    style: {
      fill: "#336734"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.24,408.51l8.06-.21a.65.65,0,0,1,.65.48l1.69,6.49a1.06,1.06,0,0,1-1,1.34c-2.91,0-7.12,0-10.78.07-4.27.12-7-.09-12,0-3,.08-4-2.94-2.72-3.25,5.73-1.42,9.47-1.14,14.35-4.34A3.49,3.49,0,0,1,378.24,408.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.55,409.55h0c-1.18.26-3.29.61-4.12-.08a1,1,0,0,1-.36-.84.54.54,0,0,1,.27-.47c.88-.53,3.9.9,4.24,1.06a.16.16,0,0,1,.1.17A.18.18,0,0,1,377.55,409.55Zm-4-1.11-.06,0a.2.2,0,0,0-.1.19.63.63,0,0,0,.23.55c.47.39,1.68.43,3.31.11C375.74,408.8,374.11,408.23,373.56,408.44Z",
    style: {
      fill: "#336734"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.55,409.55h-.13c-.9-.38-2.73-1.92-2.62-2.75,0-.2.15-.45.63-.51a1.33,1.33,0,0,1,1,.27,5,5,0,0,1,1.25,2.8.16.16,0,0,1-.07.16Zm-2.25-2.87c-.14.05-.15.13-.15.16-.07.5,1.18,1.72,2.11,2.24a4.11,4.11,0,0,0-1.06-2.24.91.91,0,0,0-.72-.2Z",
    style: {
      fill: "#336734"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.05,249.26c3.88,16.81-2.78,149.06-2.78,149.06H377.41l-5.5-110.21L351.66,398.32l-13.75-1c9-85.38,16.93-136.35,16.93-136.35l0-6.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.91,397.32l13.75,1,15.94-86.76,4.31-23.45,5.5,110.21h12.86s6.66-132.25,2.78-149.06l-38.23,5.27,0,6.44S346.9,311.94,337.91,397.32Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.12,187a162.35,162.35,0,0,0,.61,24.1c.54,5.6,1.28,10.89,2.07,15.66,1.85,11.19,3.95,19.58,4.25,22.51l-38.23,5.27c-13.94-39-8.69-61.66-8.69-61.66a74.82,74.82,0,0,1,8.77-3c.63-.17,1.27-.33,1.93-.48a143.19,143.19,0,0,1,16.25-2.24c1-.09,2.09-.16,3.11-.21C381.41,186.69,386.12,187,386.12,187Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.66,169.45c.28,5.35.85,15.39,5.3,17.94,0,0-2.77,5.27-8.76,5.81-4.53.4-4.23-4.07-4.23-4.07,2.62-1.95,2-5.26,0-9Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.52,173.81,358,180.13a17.4,17.4,0,0,1,1.2,2.7c2.1-.84,4.51-4,4.16-6.29A7.8,7.8,0,0,0,362.52,173.81Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.16,158.68c-.87,2.78-.39,8.48,3.48,6.63S347.66,153.91,346.16,158.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.16,162.44c.43,7.13,1,11.28-2.11,15.32-4.73,6.07-13.89,3.81-16.45-3.07-2.3-6.2-2.61-16.82,4-20.42A9.86,9.86,0,0,1,366.16,162.44Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.16,158.56v-8s8.48-.63,8.1,3.71c4.7,2.33,2.48,9.64-3.83,13.22-3.46-2.77-3.06-9.43-3.06-9.43C362,158.25,361.58,158.41,361.16,158.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.61,168a6.65,6.65,0,0,1-2.85,4.31c-2,1.31-3.73-.3-3.8-2.55-.06-2,.89-5.16,3.19-5.56A3.08,3.08,0,0,1,369.61,168Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.63,165.62c.07.58-.18,1.08-.56,1.12s-.74-.39-.81-1,.18-1.08.55-1.12S355.56,165,355.63,165.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.09,166.35c.07.58-.18,1.08-.56,1.12s-.74-.39-.81-1,.18-1.08.56-1.12S349,165.77,349.09,166.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.2,166.4a20.13,20.13,0,0,1-2.23,5.08,3.44,3.44,0,0,0,2.81.15Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.15,173.49a5.86,5.86,0,0,1-.75.14.17.17,0,1,1,0-.34,4.6,4.6,0,0,0,3.52-2.2.16.16,0,0,1,.22-.08.17.17,0,0,1,.08.23A4.71,4.71,0,0,1,355.15,173.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.39,163.29a.36.36,0,0,1-.34-.1,2.77,2.77,0,0,0-2.31-.89.33.33,0,0,1-.4-.27.34.34,0,0,1,.27-.4,3.42,3.42,0,0,1,2.93,1.09.33.33,0,0,1,0,.48A.4.4,0,0,1,357.39,163.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346,164.42a.28.28,0,0,1-.2,0,.34.34,0,0,1-.21-.43,3.35,3.35,0,0,1,2.21-2.18.34.34,0,0,1,.17.66,2.61,2.61,0,0,0-1.73,1.74A.33.33,0,0,1,346,164.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.92,161.52s-5-1.83-7.28-4.73c0,0-4.54,1.19-5.47,3a2.26,2.26,0,0,1-.39-3s-3.4.72-4.07,3a2.86,2.86,0,0,1-1.6-3s-1.51.57-2,3c0,0-3.75-7.82,8.64-10.06a9.24,9.24,0,0,0-2.91-.49s8.65-3.49,15.5-.3S371,158.31,364.92,161.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396,256l-12,1.6s-4.95-34.59-7.13-45.76V188l6.27-1.65L388,188a117,117,0,0,1,3.07,14.6c.59,3.74,1.12,7.74,1.59,11.79.65,5.52,1.19,11.14,1.65,16.4.72,8.49,1.2,16,1.46,20.59C395.92,254.26,396,256,396,256Z",
    style: {
      fill: "#336734"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.88,211.82s1-16.83,6.27-25.51c0,0-.13-2.48-1.18-2.88s-5.09,2-5.09,2-2.51-1.72-3.06-.92S371.93,190.63,376.88,211.82Z",
    style: {
      fill: "#336734"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.88,211.82s1-16.83,6.27-25.51c0,0-.13-2.48-1.18-2.88s-5.09,2-5.09,2-2.51-1.72-3.06-.92S371.93,190.63,376.88,211.82Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.6,260.61l1.37,1s-2-11.15-1.18-39.35c0-1.36.09-2.67.14-3.92,1-23.86,4.72-28.2,5-28.46l-3.46,1.18-6.27,2.16C343.31,213.57,349.6,260.61,349.6,260.61Z",
    style: {
      fill: "#336734"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.14,214.23s-3.46-16.36-2.43-22,4.72-3.13,4.72-3.13,3.39-2.74,4.4.28C356.83,189.38,352.17,192.66,350.14,214.23Z",
    style: {
      fill: "#336734"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.14,214.23s-3.46-16.36-2.43-22,4.72-3.13,4.72-3.13,3.39-2.74,4.4.28C356.83,189.38,352.17,192.66,350.14,214.23Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.64,214.35c-5.12-2.87-5.8-10.36-5.8-10.36.31-.12,2.21-.77,4.21-1.43C391.64,206.3,392.17,210.3,392.64,214.35Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.6,311.56l4.31-23.45-.83-12.41S365.17,297.22,367.6,311.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.75,251.34c-3.22-.22-6-.43-6-.43l-.61-13.09a4.65,4.65,0,0,1,3.37-.62,36.82,36.82,0,0,0,1.79-6.45C395,239.24,395.49,246.76,395.75,251.34Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.85 230.74 390.58 240.81 395.54 243.66 401.43 234.59 396.85 230.74",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.73,187.84c4.22.46,22.16,25.08,22.95,32.5s-10.54,20.23-10.54,20.23l-7.56-4.45s7.68-11.81,8.08-15-14.05-16.08-14.05-16.08a29.11,29.11,0,0,1-1.78-9.26C384.63,190.36,387.73,187.84,387.73,187.84Z",
    style: {
      fill: "#336734"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.13,237.83s6.45,1.38,9.05,5.44c0,0-2.7,8.45-4.63,9.37s-6.71.92-6.71.92S386.53,244.16,389.13,237.83Z",
    style: {
      fill: "#336734"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignup);
export default __webpack_public_path__ + "static/media/Sign up.a27946aa65c930898698c15af4dc7f30.svg";
export { ForwardRef as ReactComponent };